import api from './api';

export interface TapCicloOrcamentarioHasJoinProjeto {
  tapId: string;
  tapAreaId: string;
  tapDepartamentoId: string;
  tapDiretoriaId: string;
  tapEscopoAnual: string;
  nomeArea: string;
  nomeDepartamento: string;
  nomeDiretoria: string;
  tapIdFinplan: number;
  tapAno: number;
}

export interface TapJoinProjeto {
  projetoId: string;
  cicloOrcamentarioId: string;
}

export const getAllTapHasJoinProjeto = (join: TapJoinProjeto) =>
  api.get<TapCicloOrcamentarioHasJoinProjeto[]>(`tap/tapHasJoinProjeto/${join.projetoId}`);

export const updateTap = (tap: TapCicloOrcamentarioHasJoinProjeto) =>
  api.put<TapCicloOrcamentarioHasJoinProjeto>(`tap/${tap.tapId}`, tap);
